import {Button, Spin, Tabs} from "antd";
import {LoadingOutlined} from "@ant-design/icons";
import ContainerComponent from "../../../helpers/components/container.component";
import PageHeaderComponent from "../../../helpers/components/page_header.component";
import React, {useEffect, useState} from "react";
import {useHistory, useParams} from "react-router-dom";
import merchantService from "../../../services/ewallet_integration/merchant.service";
import EntranceMotion from "../../../helpers/components/entrance_motion";
import serviceHelper from "../../../helpers/functions/service.helper";
import MerchantDetail from "./detail_component/detail";
import MerchantSettlement from "./detail_component/settlement";
import MerchantUserLayout from "./detail_component/user";

const EditDetail = (default_filter) => {
    const {merchant_id} = useParams();
    const [refresh, setRefresh] = useState(false);
    const [filter, setFilter] = useState({
        tab: "info"
    })
    const [state, setState] = useState({
        loading: false,
        merchant: {},
    })
    const history = useHistory();


    // for changing filter
    const changeFilter = (key, value) => {
        let generate_filter = {...default_filter};
        generate_filter[key] = value;
        const queryString = serviceHelper?.queryString(generate_filter);
        window.history.replaceState({}, '', `${window.location.pathname}?${queryString}`);
    };


    const fetchMerchant = async () => {
        setState(state => ({...state, loading: true,}));
        const response = await merchantService.queryMerchantById(merchant_id);

        const {merchant} = response?.data;
        setRefresh(false);
        setState(state => ({...state, loading: false, merchant: merchant,}));
    }

    useEffect(() => {
        fetchMerchant();
    }, [merchant_id]);


    useEffect(() => {
        if (refresh) {
            fetchMerchant();
            setRefresh(false);
        }
    }, [refresh]);

    return (
        <>
            <Spin spinning={state?.loading} indicator={<LoadingOutlined/>}>
                <div className='mobile-padding-24' style={{textAlign: 'start'}}>
                    <div style={{marginTop: 12, marginBottom: 20,}}>
                        <ContainerComponent span={20}>
                            <div style={{marginBottom: 20}}>
                                <PageHeaderComponent title={<span style={{fontSize: 16,}}>Merchant Information</span>}
                                                     textAlign={'start'}/>
                            </div>
                            <Tabs
                                destroyInactiveTabPane
                                defaultActiveKey={filter?.tab}
                                onChange={(value) => changeFilter('tab', value)}
                                items={[
                                    {
                                        key: 'detail',
                                        label: 'Detail',
                                        children: (
                                            <>
                                                <EntranceMotion>
                                                    <MerchantDetail merchant={state?.merchant} setRefresh={setRefresh}/>
                                                </EntranceMotion>
                                            </>
                                        ),
                                    },
                                    {
                                        key: 'settlement',
                                        label: 'Settlement',
                                        children: (
                                            <>
                                                <EntranceMotion>
                                                    <MerchantSettlement merchant={state?.merchant}
                                                                        setRefresh={setRefresh} refresh={refresh}/>
                                                </EntranceMotion>
                                            </>
                                        ),
                                    },
                                    {
                                        key: 'users',
                                        label: 'Users',
                                        children: (
                                            <>
                                                <EntranceMotion>
                                                    <MerchantUserLayout merchant={state?.merchant}/>
                                                </EntranceMotion>
                                            </>
                                        ),
                                    },
                                ]}
                                className='custom-tabs'
                                animated
                            />
                        </ContainerComponent>

                        <ContainerComponent span={20}>
                            <div style={{marginTop: 20}}>
                                <Button
                                    onClick={() => history.goBack()} // go back
                                    style={{minWidth: 200}}
                                >
                                    Back to Listing
                                </Button>
                            </div>

                        </ContainerComponent>
                    </div>
                </div>
            </Spin>

        </>
    );
};

export default EditDetail;